export const SHUFFLE_PERIOD_MS = 400;
export const SHUFFLE_COUNT = 4;
